export const DummyUser = "DummyUser"
export const userDetails = "userDetails";
export const userLogout = "userLogout";
export const getLimitOptions = "getLimitOptions";
export const scrollFlagTrigger = "scrollFlagTrigger";